import { Card, Avatar, Text, Group, Stack, Badge, Collapse, Button, Anchor, Divider } from "@mantine/core";
import { useDisclosure } from '@mantine/hooks';
import { IconMail, IconPhone, IconBuilding, IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import MarkdownViewer from "./mark.viewer";

export interface ProfileCardProps {
    profileImg?: string; // The headshot of the agent, used by the avatar
    profileName: string; // The name of the agent
    profilePersonality?: string; // The personality of the agent ex) ENFJ-T
    profileAbout: string; // A short description of the agent
    profileContact: { email: string, phone: string }; // The contact info of the agent
    servicing: string[]; // The areas that the agent services
    profileCompany: string; // The company that the agent works for
    companyLink: string; // The link to the company's website - should not link to the agent's profile
}

export default function ProfileCard(props: ProfileCardProps) {
    const [opened, { toggle }] = useDisclosure(false);

    return (
        <Card withBorder radius="md" w="100%">
            <Card.Section p="md" pb={0}>
                <Group justify="space-between" align="flex-start" wrap="nowrap">
                    <Group wrap="nowrap">
                        <Avatar
                            src={props.profileImg}
                            size="lg"
                            radius="xl"
                        />
                        <Stack gap={0}>
                            <Text fw={500} size="lg">{props.profileName}</Text>
                            {props.profilePersonality && (
                                <Text c="dimmed" size="sm">{props.profilePersonality}</Text>
                            )}
                        </Stack>
                    </Group>
                    <Button
                        variant={!opened ? 'light' : 'outline'}
                        onClick={toggle}
                        leftSection={opened ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />}
                    >
                        {opened ? 'Less' : 'More'}
                    </Button>
                </Group>
            </Card.Section>

            {/* <Card.Section p="md" pt={0}>
                <Text size="sm" lineClamp={opened ? undefined : 2}>
                    {props.profileAbout}
                </Text>
            </Card.Section> */}

            <Collapse in={opened}>
                <Card.Section p="md">
                    <Text size="sm" lineClamp={opened ? undefined : 2}>
                        {props.profileAbout}
                    </Text>
                    <Group grow justify='center'>
                        <Stack gap="xs" mt={8}>
                            <Group gap="xs" wrap="nowrap">
                                <IconBuilding size={16} />
                                <Anchor href={props.companyLink} target="_blank" size="sm">
                                    {props.profileCompany}
                                </Anchor>
                            </Group>
                            <Group gap="xs" wrap="nowrap">
                                <IconMail size={16} />
                                <Text size="sm">{props.profileContact.email}</Text>
                            </Group>
                            <Group gap="xs" wrap="nowrap">
                                <IconPhone size={16} />
                                <Text size="sm">{props.profileContact.phone}</Text>
                            </Group>
                            {/* {props.profilePersonality && (<Group gap="xs">
                            <IconStar size={16} />
                            <Text size="sm">{props.profilePersonality}</Text>
                        </Group>)} */}
                            <Group gap="xs" wrap="wrap">
                                {props.servicing.map((area, index) => (
                                    <Badge key={index} variant="light">
                                        {area}
                                    </Badge>
                                ))}
                            </Group>
                        </Stack>
                        {!!props.profilePersonality && <MarkdownViewer id={props.profilePersonality} markdownFetchFn={async ii => {
                            const res = await fetch(`/api/library/personal_breakdown/${ii}_ts_agent_summary.md`);
                            return await res.text();
                        }} />}
                    </Group>
                </Card.Section>
            </Collapse>
        </Card>
    );
}